export default function (tns) {
  const galleries = Array.from(
    document.querySelectorAll(
      `.ArticleContent__entry .blocks-gallery-grid,
      .PageMain--heat-giveaway .HeatGiveaway__images-slider .blocks-gallery-grid`
    )
  )

  const wpGalleries = Array.from(
    document.querySelectorAll(
      `.ArticleContent__entry .wp-block-gallery,
      .PageMain--heat-giveaway .HeatGiveaway__images-slider .wp-block-gallery`
    )
  )

  wpGalleries.forEach(function (gallery) {
    const blockGallery = gallery.querySelector('.blocks-gallery-grid')

    if (!blockGallery) {
      galleries.push(gallery)
    }
  })

  galleries.forEach((gallery) => applyTinySlideConfigs(gallery, tns))
}

function applyTinySlideConfigs(gallery, tns) {
  removeElementsClasses(gallery)
  gallery.classList.add('tns-gallery')

  return tns({
    container: gallery,
    gutter: 0,
    nav: false,
    autoHeight: true,
    items: 1,
    edgePadding: 0,
    preventScrollOnTouch: 'force',
    responsive: {
      640: {
        gutter: 0,
        items: 2,
      },
      1024: {
        items: 3,
      },
    },
  })
}

function removeElementsClasses(gallery) {
  const items = Array.from(gallery.querySelectorAll('li, figure'))
  return items.map((item) =>
    item.classList.remove('blocks-gallery-item', 'wp-block-image')
  )
}
